<template>
    <div class="title-block">
        <div class="title-block__left">
            <div class="title-block__title">Учет устройств</div>
        </div>
    </div>

    <div class="inventory">
        <div class="inventory__alert alert alert-primary d-flex align-items-center mb-4">
            <svg class="bi flex-shrink-0 me-2" width="20" height="20" viewBox="0 0 20 20" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#prefix__clip0_405_21041)" stroke="#0678F4" stroke-width="1.667"
                    stroke-linecap="round" stroke-linejoin="round">
                    <path d="M2.5 10a7.5 7.5 0 1015 0 7.5 7.5 0 00-15 0zM10 7.5h.008" />
                    <path d="M9.172 10h.833v3.333h.833" />
                </g>
                <defs>
                    <clipPath id="prefix__clip0_405_21041">
                        <path fill="#fff" d="M0 0h20v20H0z" />
                    </clipPath>
                </defs>
            </svg>
            <div>
                Уважаемые заведующие, пожалуйста, укажите количество устройств в&nbsp;вашей аптеке.<br>
                Это не&nbsp;займет у&nbsp;вас много времени.&nbsp;2&nbsp;шага&nbsp;&mdash; 2&nbsp;минуты.
            </div>
        </div>

        <div class="inventory__drugstore mb-4">
            <div class="form-label">1. Выберите свою аптеку</div>
            <v-select
                v-model="pharmacy_id"
                :items="pharmacyes"
                item-title="street"
                item-value="id"
                variant="outlined"
                color="primary"
                density="compact"
                clearable
                @update:menu="$removeFocus"
                @click:clear="$removeFocus"
                @click:control="$removeFocus">
                <template #no-data>
                    <v-list-item>
                        <span>Данные не найдены</span>
                    </v-list-item>
                </template>
            </v-select>
        </div>

        <div class="inventory__type mb-4">
            <div class="form-label">2. Укажите количество устройств каждого типа</div>
            <p class="fw-500">
                В случае, если, например, фактически устройство в аптеке есть, но в данный момент оно на ремонте или не работает, тогда в поле с выбором количества вы его учитываете, но оставляете комментарий (специально отведенное поле "Комментарий" внизу страницы)
            </p>
            <div class="inventory-choices">
                <div class="inventory-choice">
                    <div class="inventory-choice__label">Информационный киоск</div>
                    <picture class="inventory-choice__pic">
                        <img src="/images/device_types/kiosk.png" alt="Информационный киоск">
                    </picture>
                    <div class="inventory-choice__quantity">
                        <div class="inventory-choice__quantity-label">Количество</div>
                        <div class="form-check">
                            <input v-model="kiosk" value="0" class="form-check-input" type="radio" name="infokiosk">
                            <label class="form-check-label" for="infokiosk">
                                нет
                            </label>
                        </div>
                        <div class="form-check">
                            <input v-model="kiosk" value="1" class="form-check-input" type="radio" name="infokiosk">
                            <label class="form-check-label" for="infokiosk">
                                1 шт.
                            </label>
                        </div>
                        <div class="form-check">
                            <input v-model="kiosk" value="2" class="form-check-input" type="radio" name="infokiosk">
                            <label class="form-check-label" for="infokiosk">
                                2 шт.
                            </label>
                        </div>
                    </div>
                </div>

                <div class="inventory-choice">
                    <div class="inventory-choice__label">Рекламный ТВ</div>
                    <picture class="inventory-choice__pic">
                        <img src="/images/device_types/tv.png" alt="Рекламный ТВ">
                    </picture>
                    <div class="inventory-choice__quantity">
                        <div class="inventory-choice__quantity-label">Количество</div>
                        <div class="form-check">
                            <input v-model="tv" value="0" class="form-check-input" type="radio" name="tv">
                            <label class="form-check-label" for="tv">
                                нет
                            </label>
                        </div>
                        <div class="form-check">
                            <input v-model="tv" value="1" class="form-check-input" type="radio" name="tv">
                            <label class="form-check-label" for="tv">
                                1 шт.
                            </label>
                        </div>
                        <div class="form-check">
                            <input v-model="tv" value="2" class="form-check-input" type="radio" name="tv">
                            <label class="form-check-label" for="tv">
                                2 шт.
                            </label>
                        </div>
                        <div class="form-check">
                            <input v-model="tv" value="3" class="form-check-input" type="radio" name="tv">
                            <label class="form-check-label" for="rektv">
                                3 шт.
                            </label>
                        </div>
                        <div class="form-check">
                            <input v-model="tv" value="4" class="form-check-input" type="radio" name="tv">
                            <label class="form-check-label" for="tv">
                                4 шт.
                            </label>
                        </div>
                    </div>
                </div>

                <div class="inventory-choice">
                    <div class="inventory-choice__label">Терминал электронной очереди</div>
                    <picture class="inventory-choice__pic">
                        <img src="/images/device_types/kiosk_eq.png" alt="Терминал электронной очереди">
                    </picture>
                    <div class="inventory-choice__quantity">
                        <div class="inventory-choice__quantity-label">Количество</div>
                        <div class="form-check">
                            <input v-model="kiosk_eq" value="0" class="form-check-input" type="radio" name="kiosk_eq">
                            <label class="form-check-label" for="kiosk_eq">
                                нет
                            </label>
                        </div>
                        <div class="form-check">
                            <input v-model="kiosk_eq" value="1" class="form-check-input" type="radio" name="kiosk_eq">
                            <label class="form-check-label" for="kiosk_eq">
                                1 шт.
                            </label>
                        </div>
                        <div class="form-check">
                            <input v-model="kiosk_eq" value="2" class="form-check-input" type="radio" name="kiosk_eq">
                            <label class="form-check-label" for="kiosk_eq">
                                2 шт.
                            </label>
                        </div>
                    </div>
                </div>

                <div class="inventory-choice">
                    <div class="inventory-choice__label">ТВ электронной очереди</div>
                    <picture class="inventory-choice__pic">
                        <img src="/images/device_types/tv_eq.png" alt="ТВ электронной очереди">
                    </picture>
                    <div class="inventory-choice__quantity">
                        <div class="inventory-choice__quantity-label">Количество</div>
                        <div class="form-check">
                            <input v-model="tv_eq" value="0" class="form-check-input" type="radio" name="tv_eq">
                            <label class="form-check-label" for="tv_eq">
                                нет
                            </label>
                        </div>
                        <div class="form-check">
                            <input v-model="tv_eq" value="1" class="form-check-input" type="radio" name="tv_eq">
                            <label class="form-check-label" for="tv_eq">
                                1 шт.
                            </label>
                        </div>
                        <div class="form-check">
                            <input v-model="tv_eq" value="2" class="form-check-input" type="radio" name="tv_eq">
                            <label class="form-check-label" for="tv_eq">
                                2 шт.
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="inventory__comment">
            <div class="mb-4">
                <div class="form-label">Комментарий</div>
                <textarea v-model="comment" :maxlength="commentLimit" class="form-control w-100" rows="5"></textarea>
            </div>
            <div class="d-flex align-items-stretch">
                <button v-on:click="save" class="btn btn-lg btn-primary me-3 w-100">Сохранить</button>
                <button v-on:click="cancel" class="btn btn-lg btn-outline-dark w-100">Отменить</button>
            </div>
        </div>

        <div class="modal-mask" v-if="modalThanks">
            <div class="modal-wrapper">
                <div class="modal-container" style="max-width: 480px;">
                    <div class="modal-header">
                        <h6 class="modal-title color-accent">Благодарим за уделенное время!</h6>
                    </div>
                    <div class="modal-footer">
                        <button v-on:click="closeModal" class="btn btn-md btn-success m-1">Закрыть</button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <Alert />
</template>

<script>
import Alert from '../../../alerts/Alert.vue';
import { mapMutations } from 'vuex/dist/vuex.cjs.js';

export default {
    name: 'DevicesInventoryComponent',
    components: { Alert },
    data: function () {
        return {
            commentLimit: 700,
            pharmacy_id: '',
            modalThanks: false,
            comment: null,
            tv: null,
            kiosk: null,
            kiosk_eq: null,
            tv_eq: null,
            cash_register_monitor: null,
            pharmacyes: [
                {
                    id: null,
                    street: null
                }
            ],
        };
    },
    methods: {
        ...mapMutations('alerts', ['addAlert']),
        getPharmacyes: async function () {
            let resp = await axios.get('/organizational/addresses/get/pharmacyes', {
                params: {
                    limit: 2000
                }})
                .catch(_ => {
                    alert('Не удалось получить список аптек, что то пошло не так');
                });

            if (resp.data.status === 'ok') {
                for (let i = 0; i < resp.data.items.length; i++) {
                    this.pharmacyes[i] = {
                        id: resp.data.items[i].id,
                        street: resp.data.items[i].number + ', ' + resp.data.items[i].street
                    }
                }
            }
        },
        save: async function() {
            if (this.pharmacy_id === '' || this.pharmacy_id === null || !Number.isInteger(this.pharmacy_id)) {
                this.addAlert({ type: 'warning', title: 'Предупреждение', text: 'Выберете аптеку' });
                return;
            }

            if (this.kiosk === null) {
                this.addAlert({ type: 'warning', title: 'Предупреждение', text: 'Укажите количество Информационных киосков!' });
                return;
            }

            if (this.kiosk_eq === null) {
                this.addAlert({ type: 'warning', title: 'Предупреждение', text: 'Укажите количество Терминалов электронной очереди!' });
                return;
            }

            if (this.tv === null) {
                this.addAlert({ type: 'warning', title: 'Предупреждение', text: 'Укажите количество Рекламных ТВ!' });
                return;
            }

            if (this.tv_eq === null) {
                this.addAlert({ type: 'warning', title: 'Предупреждение', text: 'Укажите количество ТВ Электронной очереди!' });
                return;
            }

            if (this.kiosk < 0 || this.kiosk_eq < 0 || this.tv < 0 || this.tv_eq < 0) {
                this.addAlert({ type: 'warning', title: 'Предупреждение', text: 'Количество устройств не может быть отрицательным!' });
                return;
            }

            await axios.post('/save/device/data',{
                location_id: this.pharmacy_id,
                kiosk: this.kiosk,
                kiosk_eq: this.kiosk_eq,
                tv: this.tv,
                tv_eq: this.tv_eq,
                cash_register_monitor: this.cash_register_monitor,
                comment: this.comment
            }).then(response => {
                return response.data.status !== undefined && response.data.status === 'ok';
            });

            this.modalThanks = true;
        },
        cancel: async function() {
            let confirmation = confirm('Очистить введенные данные?');

            if (!confirmation) {
                return;
            }

            this.pharmacy_id = '';
            this.kiosk = null;
            this.kiosk_eq = null;
            this.tv = null;
            this.tv_eq = null;
            this.cash_register_monitor = null;
            this.comment = null;
        },
        closeModal: async function() {
            window.location.reload();
        },
    },
    mounted() {
        this.getPharmacyes();
    }
};
</script>

<style scoped lang="scss">
.inventory {
    &__alert {
        max-width: 650px;
    }

    &__drugstore {
        max-width: 650px;
    }

    &__type {
        max-width: 882px;
    }

    &__comment {
        max-width: 402px;
    }
}

.inventory-choices {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 40px;
    max-width: 768px;

    @media screen and (max-width: 991.98px) {
        display: flex;
        flex-direction: column;
        gap: 30px;
    }
}

.inventory-choice {
    display: grid;
    grid-template-columns: 270px auto;
    gap: 15px 32px;

    @media screen and (max-width: 575.98px) {
        display: flex;
        flex-direction: column;
        gap: 8px;
    }

    &__label {
        font-size: 16px;
        font-weight: 600;
        line-height: 1;
        align-self: flex-start;
        grid-column: span 2;
    }

    &__pic {
        display: block;
        width: 100%;
        height: min-content;

        @media screen and (max-width: 575.98px) {
            max-width: 210px;
        }

        &>img {
            display: block;
            width: 100%;
            @media screen and (max-width: 575.98px) {
                height: 210px;
            }
            height: 280px;
        }
    }

    &__quantity {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 2px;
    }

    &__quantity-label {
        font-size: 14px;
        font-weight: 600;
    }
}
</style>